import { format } from 'date-fns'
import { ar, bn, de, el, es, fr, it, pt, sr } from 'date-fns/locale'
import { ref, watch } from 'vue'
import useLocale from './useLocale'

export default function useFormatDate(date: string, formatter = 'dd/MM/yyyy') {
  const locales = {
    ar,
    es,
    de,
    it,
    fr,
    pt,
    el,
    bn,
    sr,
  }

  const { currentLocale } = useLocale()
  const formattedDate = ref('')

  watch(
    currentLocale,
    (locale) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
      // @ts-ignore
      const localeObj = locales[locale]

      try {
        formattedDate.value = format(new Date(date), formatter, {
          locale: locale && locale === 'en' ? undefined : localeObj,
        })
      } catch (e) {
        console.warn('Invalid date:', date, e)
      }
    },
    {
      deep: true,
      immediate: true,
    }
  )

  return {
    formattedDate,
  }
}
